import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import ICON_BETA from '@/assets/sideBar/icon_beta.png';

interface IProps {
  menuItem: IMenuItem;
}

interface IMenuItem {
  id: number;
  title: string;
  link: string[];
  uri: { active: string; notActive: string };
}

function SideMenuItem({ menuItem }: IProps) {
  const [isCurrent, setIsCurrent] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (menuItem.link.includes(pathname)) {
      setIsCurrent(true);
    } else {
      setIsCurrent(false);
    }
  }, [pathname]);

  return (
    <Container isCurrent={isCurrent}>
      <Icon
        src={isCurrent ? menuItem.uri.active : menuItem.uri.notActive}
        width='24px'
        height='24px'
      />
      <Title isCurrent={isCurrent}>
        {menuItem.title}
        {menuItem.id === 8 && <img src={ICON_BETA} alt='배타' height={20} />}
      </Title>
      {isCurrent && (
        <Triangle
          isActive={isCurrent}
          isWhite={pathname === '/' || pathname === '/home/notice/detail'}
        />
      )}
    </Container>
  );
}

const Container = styled.li<{ isCurrent: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 17px 0 17px 32px;
  position: relative;
  gap: 14px;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;
`;

const Icon = styled.img`
  object-fit: contain;
  margin-bottom: 2px;
`;

const Title = styled.h3<{ isCurrent: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: ${(props) => props.theme.fontSize.small};
  font-weight: ${(props) => props.theme.fontWeight.medium};
  line-height: ${(props) => props.theme.lineHeight.small};
  color: ${(props) => (props.isCurrent ? '#FFFFFF' : '#7CA7FA')};
`;
const Triangle = styled.div<{ isActive: boolean; isWhite?: boolean }>`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 22px solid transparent;
  border-right: 16px solid
    ${(props) =>
      !props.isActive
        ? 'transparent'
        : !props.isWhite
        ? props.theme.mono[5]
        : '#fff'};
  border-bottom: 22px solid transparent;
  border-left: 16px solid transparent;
`;
export default SideMenuItem;
